import type { FaireProductEntity } from "../../entity_types/product";

export const p_fr26cfbpsa: FaireProductEntity = {
  token: "p_fr26cfbpsa",
  type: "product",
  name: "Bear Hug Gourmet Popcorn - best seller",
  brandToken: "b_pffy5dqdsz",
  brandName: "Bombshell Sweets",
  imageUrl:
    "https://cdn.faire.com/fastly/d9b4dd14d81ba81c2fdc4e106b2681c25706857d3a72ec99b0765e2e4e0b02cd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d1c375f9d935118285fd396d915932bc68051f59408a5b324d1ac4be8b10f432.jpeg",
    "https://cdn.faire.com/fastly/aea44a774fb6748b5de83ce0ce77b6d91eb81ddc88dfcd7e0a7403cf72a88029.jpeg",
    "https://cdn.faire.com/fastly/95a5d06449ba12d28d0e9e8cd3d0ac4efb07b0baaae2c0dc8eb5f2f03c2a9092.png",
  ],
  priceDollars: 5.2,
  description:
    "Three flavors, one irresistible embrace. Bear Hug layers the warmth of churro, the buttery sweetness of caramel, and the richness of chocolate onto fluffy popcorn. The tri-colored mix of cream, light brown, and dark brown kernels creates a striking visual that matches the big, cozy flavor experience.\nA top seller!",
  tags: [],
  msrpDollars: 9.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:08.780Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
